const EventIcon = ({ color = "#828282" }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0625 2.625H15.75V1.3125C15.75 0.961875 15.4612 0.65625 15.0938 0.65625H14.4375C14.07 0.65625 13.7812 0.961875 13.7812 1.3125V2.625H7.21875V1.3125C7.21875 0.961875 6.93 0.65625 6.5625 0.65625H5.90625C5.53875 0.65625 5.25 0.961875 5.25 1.3125V2.625H3.9375C2.74463 2.625 1.78125 3.58838 1.78125 4.78125V17.3438C1.78125 18.5366 2.74463 19.5 3.9375 19.5H17.0625C18.2554 19.5 19.2188 18.5366 19.2188 17.3438V4.78125C19.2188 3.58838 18.2554 2.625 17.0625 2.625ZM17.0625 17.3438H3.9375V8.53125H17.0625V17.3438ZM17.0625 6.90625H3.9375V4.78125H17.0625V6.90625Z"
      fill={color}
    />
  </svg>
);

export default EventIcon;

